import React, { useEffect, useRef } from "react";

// ─────────────────────────────────────────────
// COMPONENT 1: ScrollProgressBar
// PLACEMENT: First child inside <nav>, spanning full width at bottom
// Usage: <ScrollProgressBar />
// ─────────────────────────────────────────────
export function ScrollProgressBar() {
  const fillRef = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      if (fillRef.current) fillRef.current.style.width = pct + "%";
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <style>{`
        .rs-progress-track {
          position: absolute;
          bottom: -1px;
          left: 0;
          right: 0;
          height: 2px;
          background: transparent;
          z-index: 101;
        }
        .rs-progress-fill {
          height: 100%;
          width: 0%;
          background: linear-gradient(90deg, #1DA1F2, #49D6FF, #8CEBFF);
          box-shadow: 0 0 10px rgba(73, 214, 255, 0.6);
          border-radius: 0 2px 2px 0;
          transition: width 0.1s linear;
        }
      `}</style>
      <div className="rs-progress-track">
        <div className="rs-progress-fill" ref={fillRef} />
      </div>
    </>
  );
}
